import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    name: String
  }

  //  this could be a useful utility
  debugLog(...messages) {
    if (this.application.debug) {
      console.log(`[${this.identifier}]`, ...messages)
    }
  }

  connect() {
    this.observeStreamConnection()
  }

  observeStreamConnection() {
    const streamSource = this.element

    if (streamSource.hasAttribute('connected')) {
      this.onConnected()
    } else {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'connected') {
            this.onConnected()
            this.observer.disconnect()
          }
        })
      })
      this.observer.observe(streamSource, { attributes: true })
    }
  }

  onConnected() {
    this.debugLog(`${this.nameValue} stream is connected`)
    const event = new CustomEvent(`${this.nameValue}:connected`)
    this.element.dispatchEvent(event)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
